(function() {
  let currentStep = 0;
  let building = false;
  let firstLoad = true;
  let totalSteps = 0;
  let stepsLocked = false;
  let initialized = false;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;


  let isScrolling = false;
  let scrollTimeout = null;

  if (isMobile) {
    window.addEventListener('scroll', () => {
      isScrolling = true;
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
      }, 500);
    }, { passive: true });
  }

  const stepNames = [
    'Diamond Shape',
    'Metal',
    'Hidden Stone',
    'Engraving',
    'Size',
    'Add to cart'
  ];

  /* Deep link into a step: /products/<handle>?variant=<id>&step=hidden-stone
     (also accepts shape | metal | engraving or a 0-based index). Used by the
     collection ring cards so a pre-configured ring opens on the hidden stone
     step. The requested step is kept until it has actually been applied,
     because Variant King can re-fire vkcl:variant:changed during load and
     that handler resets the wizard to step 0. */
  const requestedStep = (() => {
    try { return new URLSearchParams(window.location.search).get('step'); } catch (e) { return null; }
  })();
  let requestedStepPending = !!requestedStep;
  const pageStartedAt = Date.now();

  function stepIndexFor(name) {
    const steps = document.querySelectorAll('.olvr-step');
    if (!steps.length) return -1;
    const bySelector = {
      'shape': 'input[id*="__main-1-"]',
      'metal': 'input[id*="__main-2-"]',
      'hidden-stone': 'input[id*="__main-3-"]',
      'secret-stone': 'input[id*="__main-3-"]',
      'engraving': '.gpo-label, .gpo-options-group'
    }[String(name).toLowerCase()];
    if (bySelector) {
      for (let i = 0; i < steps.length; i++) {
        if (steps[i].querySelector(bySelector)) return i;
      }
      return -1;
    }
    const n = parseInt(name, 10);
    if (!isNaN(n)) return Math.min(Math.max(n, 0), steps.length - 1);
    return -1;
  }

  function applyRequestedStep() {
    if (!requestedStepPending) return;
    const idx = stepIndexFor(requestedStep);
    if (idx < 0) return;
    requestedStepPending = false;
    if (idx !== currentStep) {
      currentStep = idx;
      buildSteps(true);
    }
  }

  function getNextStepName(currentIdx, total) {
    if (currentIdx >= total - 1) {
      return 'Add to cart';
    }
    return stepNames[currentIdx] || 'Next';
  }

  function initSizesShowMore() {
    if (isMobile) return;

    const wrappers = document.querySelectorAll('.finger-sizes .gpo-oos--show');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.showMoreInit) return;

      const items = wrapper.querySelectorAll('.gpo-radio');

      wrapper.dataset.showMoreInit = 'true';

      const visibleValues = [];
      for (let v = 4; v <= 8.5; v += 0.5) {
        visibleValues.push(v);
      }

      items.forEach((item) => {
        const valueStr = item.querySelector('input')?.value;
        const value = parseFloat(valueStr);

        if (!visibleValues.includes(value)) {
          item.classList.add('gpo-hidden-size');
        }
      });

      const hiddenCount = items.length - visibleValues.length;

      const showMoreBtn = document.createElement('button');
      showMoreBtn.type = 'button';
      showMoreBtn.className = 'gpo-show-more-btn';
      showMoreBtn.innerHTML = `Show more <span class="gpo-show-more-count">(+${hiddenCount})</span>`;
      
      wrapper.appendChild(showMoreBtn);

      showMoreBtn.addEventListener('click', () => {
        const isExpanded = wrapper.classList.toggle('gpo-expanded');

        if (isExpanded) {
          showMoreBtn.innerHTML = 'Show less';
        } else {
          showMoreBtn.innerHTML = `Show more <span class="gpo-show-more-count">(+${hiddenCount})</span>`;
        }
      });
    });
  }

  let sizesCheckInterval = null;

  function watchForSizesBlock() {
    if (isMobile) return;

    initSizesShowMore();

    /* Speed: watch for the Globo size block instead of polling every 500ms. */
    if (!sizesCheckInterval) {
      const root = document.querySelector('.product__info-container') || document.body;
      let t = null;
      const obs = new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(initSizesShowMore, 120);
      });
      obs.observe(root, { childList: true, subtree: true });
      sizesCheckInterval = obs;
      setTimeout(() => {
        if (sizesCheckInterval) {
          sizesCheckInterval.disconnect();
          sizesCheckInterval = null;
        }
      }, 30000);
    }
  }

  function updateSummaryBlock() {
    let summary = document.querySelector('.olvr-summary-block');
    
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'olvr-summary-block';
      const container = document.querySelector('.product__summary-block');
      if (container) {
        container.appendChild(summary);
      } else {
        document.body.appendChild(summary);
      }
    }

    const { title, options } = collectSelectedOptionsAndTitle();
    const price = getProductPrice();
    const soldOut = isVariantSoldOut();
    const soldOutLabel = soldOut ? '<span class="olvr-sold-out-label">Sold Out</span>' : '';
    const shareText = isMobile ? 'Share' : 'Share your design';

    summary.innerHTML = `
      <div class="olvr-summary-info">
        <div class="olvr-summary-title">${title} ${soldOutLabel}</div>
        ${options ? `<div class="olvr-summary-options">${options}</div>` : ''}
        <div class="olvr-summary-price">${price}<span class="olvr-summary-price-note">${isMobile ? 'Setting only' : 'Setting only · your diamond is next'}</span></div>
      </div>
      <div class="olvr-summary-actions">
        <button class="olvr-share-btn" aria-label="Share" type="button">
          <span class="share-label">${shareText}</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"/>
          </svg>
        </button>
      </div>
    `;

    // Relocate the "Shipping calculated at checkout" + Shop Pay installment widget
    // from their original spot in the price block into the summary, below the price.
    if (!updateSummaryBlock._cachedTax) {
      updateSummaryBlock._cachedTax = document.querySelector('.product__tax') || null;
    }
    if (!updateSummaryBlock._cachedInstallment) {
      const installmentForm = document.querySelector('.product__info-container form.installment');
      updateSummaryBlock._cachedInstallment = installmentForm ? installmentForm.parentElement : null;
    }
    const summaryPriceEl = summary.querySelector('.olvr-summary-price');
    if (summaryPriceEl) {
      let cursor = summaryPriceEl;
      if (updateSummaryBlock._cachedTax) {
        cursor.after(updateSummaryBlock._cachedTax);
        cursor = updateSummaryBlock._cachedTax;
      }
      if (updateSummaryBlock._cachedInstallment) {
        cursor.after(updateSummaryBlock._cachedInstallment);
      }
    }
  }

  function cleanOptionText(text) {
    if (!text) return '';
    return text
      .replace(/Variant sold out or unavailable/gi, '')
      .replace(/sold out/gi, '')
      .replace(/unavailable/gi, '')
      .replace(/out of stock/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function collectSelectedOptionsAndTitle() {
    let title = '';
    const options = [];

    // Variant King 
    const kingSelected = document.querySelector('variant-king-combined-listing .swatch-selected[current-product="true"]');
    if (kingSelected) {
      title = kingSelected.getAttribute('data-value') || '';
    }

    if (!title) {
      const kingLi = document.querySelector('variant-king-combined-listing li[aria-checked="true"]');
      if (kingLi) {
        title = kingLi.getAttribute('aria-label') || kingLi.getAttribute('orig-value') || '';
      }
    }

    // Fallback
    if (!title) {
      title = document.querySelector('.product__title, .product-title, h1.title')?.textContent?.trim() || 'Product';
    }

    document.querySelectorAll('.product__info-container input[type="radio"]:checked, .product__info-container input[type="checkbox"]:checked').forEach(input => {
      if (input.closest('variant-king-combined-listing')) return;
      
      const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
      const text = cleanOptionText(label?.textContent || input.value);
      if (text && !options.includes(text)) options.push(text);
    });

    document.querySelectorAll('.product__info-container select').forEach(select => {
      if (select.value && select.selectedOptions[0]) {
        const text = cleanOptionText(select.selectedOptions[0].textContent);
        if (text && !options.includes(text)) options.push(text);
      }
    });

    document.querySelectorAll('.gpo-option-image.selected, .gpo-swatch.selected').forEach(el => {
      const text = cleanOptionText(el.getAttribute('title') || el.getAttribute('data-value') || el.textContent);
      if (text && !options.includes(text)) options.push(text);
    });

    return {
      title: cleanOptionText(title),
      options: options.length > 0 ? options.join(', ') : ''
    };
  }

  function isVariantSoldOut() {
    const submitBtn = document.querySelector('.product-form__submit');
    if (!submitBtn) return false;
    
    const btnText = submitBtn.textContent?.toLowerCase() || '';
    const isDisabled = submitBtn.disabled;
    
    return isDisabled && (btnText.includes('sold out') || btnText.includes('unavailable'));
  }

  function getProductPrice() {
    const priceSelectors = [ 
      '.price-item--regular',
      '.price__regular .price-item',
      '.product__price',
      '.price .money',
      '[data-product-price]',
      '.product-form__info-content .price',
      '.price-item'
    ];

    for (const selector of priceSelectors) {
      const el = document.querySelector(selector);
      if (el && el.textContent?.trim()) {
        return el.textContent.trim();
      }
    }

    return '';
  }

  function getProductTitle() {
    const kingSelected = document.querySelector('variant-king-combined-listing .swatch-selected[current-product="true"]');
    if (kingSelected) {
      const title = kingSelected.getAttribute('data-value');
      if (title) return title;
    }

    const kingLi = document.querySelector('variant-king-combined-listing li[aria-checked="true"]');
    if (kingLi) {
      const title = kingLi.getAttribute('aria-label') || kingLi.getAttribute('orig-value');
      if (title) return title;
    }

    // Fallback 
    const pageTitle = document.querySelector('.product__title, .product-title, h1.title')?.textContent?.trim();
    return pageTitle || 'Product';
  }

  function buildSteps(force = false) {

    if (isMobile && isScrolling && !force) return;
    
    if (building) return;
    building = true;

    const active = document.activeElement;
    let caretPos = null;
    const isEditable = active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.tagName === "SELECT");
    if (isEditable) {
      try { caretPos = active.selectionStart; } catch(e) {}
    }

    const container = document.querySelector('.product__info-container');
    if (!container) { building = false; return; }

    container.querySelectorAll('.olvr-step').forEach(w => w.children.length && w.replaceWith(...w.children));

    const steps = [];

    const wrap = el => {
      if (el.closest('.olvr-step')) return;
      const div = document.createElement('div');
      div.className = 'olvr-step';
      el.before(div);
      div.appendChild(el);
      steps.push(div);
    };

    const king = container.querySelector('variant-king-combined-listing');
    if (king && getComputedStyle(king).display !== 'none') {
      wrap(king);
    }

    if (king) {
      container.querySelectorAll('variant-selects fieldset, .gpo-options-group, .product-form__input, fieldset, div[id^="option-"]').forEach(el => {
        if (el.querySelector && el.querySelector('input, select, textarea, .gpo-option-image') &&
            !el.closest('.olvr-step') &&
            getComputedStyle(el).display !== 'none' &&
            getComputedStyle(el).visibility !== 'hidden' &&
            /* The ring's own options (shape, metal, hidden stone) are always a
               step, even if they measure 0 tall for a moment while a pick is
               being swapped in (Oct 23). */
            (el.offsetHeight > 0 || !!el.closest('variant-selects'))) {
          wrap(el);
        }
      });
    }

    if (firstLoad && steps.length > 0) {
      totalSteps = steps.length;
      stepsLocked = true;
      firstLoad = false;
    } else if (!stepsLocked) {
      totalSteps = steps.length;
    } else if (steps.length > totalSteps &&
               container.querySelectorAll('variant-selects').length === 1 &&
               container.querySelectorAll('.gpo-options-group').length <= 1) {
      /* Oct 25: a step that showed up late (the engraving block) is now on
         the page and sorted, so count it. Skipped while a pick is being
         swapped in, when old and new copies of the options are both there. */
      totalSteps = steps.length;
    }

    steps.forEach((s, i) => s.style.display = i === currentStep ? 'block' : 'none');

    const productForm = container.querySelector('.product-form');
    if (productForm) productForm.style.display = currentStep === totalSteps - 1 ? 'block' : 'none';

    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery) mediaGallery.classList.toggle('with-gallery__section', currentStep > 0);

    updateButtons(totalSteps);
    updateSummaryBlock();
    updateStepCounter();

    watchForSizesBlock();

    if (isEditable) {
      let restored = active.id ? document.getElementById(active.id) : document.querySelector(`[name="${active.name}"]`);
      if (restored) {
        restored.focus();
        if (caretPos !== null && restored.setSelectionRange) restored.setSelectionRange(caretPos, caretPos);
      }
    }

    building = false;
  }

  function updateButtons(total) {
    const prev = document.getElementById('step-prev');
    const next = document.getElementById('step-next');
    if (!prev || !next) return;

    prev.disabled = currentStep === 0;

    if (!initialized) {
      next.innerHTML = next.dataset.icon || '';
      next.disabled = true;
      next.classList.remove('olvr-final-submit');
      return;
    }

    const isLastStep = currentStep === total - 1;

    next.classList.toggle('olvr-final-submit', isLastStep);

    if (isLastStep) {
      const ctaLabel = document.getElementById('add-diamond-link') ? 'Choose Diamond' : 'Add to cart';
      next.innerHTML = `${ctaLabel} <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      const realBtn = document.querySelector('.product-form__submit');
      next.disabled = realBtn?.disabled || (realBtn?.textContent || '').includes('Unavailable');
    } else {
      const nextStepName = 'Next';
      next.innerHTML = `${nextStepName} <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      
      let filled = false;

      if (currentStep === 0) {
        filled = !!document.querySelector('variant-king-combined-listing .swatch-selected[current-product="true"], variant-king-combined-listing li[aria-checked="true"]');
        if (!filled) {
          const idInput = document.querySelector('input[name="id"]');
          filled = idInput && idInput.value && idInput.value !== '';
        }
      } else {
        const step = document.querySelectorAll('.olvr-step')[currentStep];
        const hasField = step?.querySelector('input, select, textarea');
        filled = !!hasField;
      }

      next.disabled = !filled;
      void next.offsetLeft;
    }
  }

  function updateStepCounter() {
    if (!initialized || totalSteps === 0) return;

    const steps = document.querySelectorAll('.olvr-step');
    const activeStep = steps[currentStep];
    if (!activeStep) return;

    // Remove ALL existing counters everywhere — avoids stale/duplicate spans
    document.querySelectorAll('.olvr-step-count').forEach(el => el.remove());

    // Pick the header element for this step.
    // GPO (engraving) step: use the whole .gpo-label so the counter lands
    // after the title text AND the info tooltip icon.
    let heading = activeStep.querySelector('.gpo-label');
    if (!heading) {
      heading = activeStep.querySelector(
        '.swatch-option-name, .form__label, legend'
      );
    }
    if (!heading) return;

    const counter = document.createElement('span');
    counter.className = 'olvr-step-count';
    counter.textContent = `${currentStep + 1}/${totalSteps + 1}`;
    heading.appendChild(counter);
  }

  document.getElementById('step-prev')?.addEventListener('click', () => {
    if (currentStep > 0) {
      currentStep--;
      buildSteps(true);
    }
  });

  document.getElementById('step-next')?.addEventListener('click', () => {
    if (currentStep < totalSteps - 1) {
      currentStep++;
      buildSteps(true);
    } else {
      const diamondLink = document.getElementById('add-diamond-link');
      if (diamondLink) {
        diamondLink.click();
      } else {
        document.querySelector('.product-form__submit:not([disabled])')?.click();
      }
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.closest('.product__info-container')) {
      updateSummaryBlock();
  
      if (isMobile) {
        buildSteps(true);
      }
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.gpo-option-image, .gpo-swatch, variant-king-combined-listing')) {
      setTimeout(updateSummaryBlock, 100);
    
      if (isMobile) {
        setTimeout(() => buildSteps(true), 300);
      }
    } 
  });

  let lastHTML = '';
  let isHoveringTooltip = false;

  function isElementWithClosest(el) {
    return el instanceof Element || el instanceof HTMLElement;
  }

  document.addEventListener('mouseenter', (e) => {
    if (isElementWithClosest(e.target) &&
        e.target.closest('.variant-tooltip, .variant-option-title, [data-tooltip], .label-tooltip')) {
      isHoveringTooltip = true;
    }
  }, true);

  document.addEventListener('mouseleave', (e) => {
    if (isElementWithClosest(e.target) &&
        e.target.closest('.variant-tooltip, .variant-option-title, [data-tooltip], .label-tooltip')) {
      isHoveringTooltip = false;
    }
  }, true);

  /* Speed: react to changes in variant-selects instead of re-reading it 4 times a second. */
  if (!isMobile) {
    let vsObserved = null;
    let vsTimer = null;
    let unwrappedTries = 0;
    let lastTryAt = 0;
    /* Missing options fix (Oct 23, 2026). Desktop: sometimes a hidden stone
       pick changed the stone and the row of stones vanished. A pick swaps in a
       fresh copy of the options, not yet sorted into steps, and the steps are
       rebuilt here. That rebuild was skipped while the mouse was over a tooltip
       (the info icon by the step title, say), and if that tooltip was removed
       in the swap the "mouse left" never came, so the rebuild never ran.
       A fresh, unsorted copy is now always rebuilt (up to 5 tries in a row);
       the tooltip pause only applies to small in-place changes. */
    const checkVariantSelects = () => {
      if (building) { clearTimeout(vsTimer); vsTimer = setTimeout(checkVariantSelects, 100); return; }
      const vs = document.querySelector('variant-selects');
      if (!vs) return;
      /* Broken: some of the ring's options aren't in a step. Oct 25: a pick
         swaps the options in with a short page transition, the old and new
         copies are both on the page for a moment, and the rebuild could run
         on the old copy and leave the new one unsorted, so the row of options
         vanished. Now every copy on the page is checked, and any change in
         the info column (not just inside the options) triggers a check. */
      let broken = Array.prototype.some.call(document.querySelectorAll('.product__info-container variant-selects fieldset'), (f) => !f.closest('.olvr-step'));
      /* Up to 5 tries in a row, then a pause. The count starts over once a
         second has gone by without a try, so a swap that keeps the page busy
         for a while (Platinum did) still gets fixed when it settles. */
      if (!broken || Date.now() - lastTryAt > 1000) unwrappedTries = 0;
      if (broken && ++unwrappedTries > 5) {
        broken = false;
        clearTimeout(vsTimer); vsTimer = setTimeout(checkVariantSelects, 1100);
      }
      if (broken) lastTryAt = Date.now();
      if (broken) isHoveringTooltip = false;
      if (isHoveringTooltip) return;
      if (broken || vs.innerHTML !== lastHTML) {
        buildSteps();
        lastHTML = vs.innerHTML; /* after the rebuild, so the rebuild itself doesn't count as a change */
        if (broken) { clearTimeout(vsTimer); vsTimer = setTimeout(checkVariantSelects, 300); } /* check it took */
      }
    };
    const vsObserver = new MutationObserver(() => {
      clearTimeout(vsTimer);
      vsTimer = setTimeout(checkVariantSelects, 100);
    });
    const attachVsObserver = () => {
      const vs = document.querySelector('variant-selects');
      if (!vs || vs === vsObserved) return;
      vsObserver.disconnect();
      vsObserver.observe(vs, { childList: true, subtree: true, attributes: true, characterData: true });
      vsObserved = vs;
    };
    attachVsObserver();
    /* variant-selects can be swapped out on a section re-render; re-attach when that happens. */
    const infoRoot = document.querySelector('.product__info-container') || document.body;
    new MutationObserver(() => {
      const vs = document.querySelector('variant-selects');
      if (vs && vs !== vsObserved) attachVsObserver();
      /* Any change in the info column gets a check (cheap when nothing is
         broken), so the end of a swap is never missed. */
      clearTimeout(vsTimer);
      vsTimer = setTimeout(checkVariantSelects, 150);
    }).observe(infoRoot, { childList: true, subtree: true });
    document.addEventListener('mouseleave', (e) => {
      if (isElementWithClosest(e.target) &&
          e.target.closest('.variant-tooltip, .variant-option-title, [data-tooltip], .label-tooltip')) {
        setTimeout(checkVariantSelects, 50);
      }
    }, true);
  }

  /* Speed: run cb as soon as Variant King, the option fieldsets and the Globo
     engraving block have rendered and the info column has been quiet for a moment,
     instead of waiting a fixed 1.5s. Falls back after maxWait. */
  function whenBuilderReady(cb, maxWait) {
    const root = document.querySelector('.product__info-container') || document.body;
    let quietTimer = null;
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      obs.disconnect();
      clearTimeout(quietTimer);
      clearTimeout(capTimer);
      cb();
    };
    const ready = () =>
      root.querySelector('variant-king-combined-listing') &&
      root.querySelector('variant-selects fieldset') &&
      root.querySelector('.gpo-options-group');
    const check = () => {
      if (ready()) {
        clearTimeout(quietTimer);
        quietTimer = setTimeout(finish, 200);
      }
    };
    const obs = new MutationObserver(check);
    obs.observe(root, { childList: true, subtree: true });
    const capTimer = setTimeout(() => {
      if (root.querySelector('variant-king-combined-listing')) finish();
    }, maxWait);
    check();
  }

  /* Late engraving block (Oct 23, 2026). whenBuilderReady gives up waiting after
     a short cap, and the step count is then locked. If the Globo engraving block
     (.gpo-options-group) arrives after that, e.g. a slow phone or a cold cache
     right after a theme publish, the engraving step was never added and Next
     skipped straight past it. Keep watching for it for a while and, when it
     shows up, count the steps again, staying on the step the shopper is on.
     v2 (Oct 23, evening): still missing often, mostly when landing from the
     Shop Rings cards. The block can already be on the page but hidden while
     Globo sets it up, and it then appears by a style or class change, which
     v1 didn't watch for, and v1 also used up its tries while it was hidden.
     Now style and class changes count too, a try is only used once the block
     is actually showing, and it keeps watching for 30 seconds. */
  let lateGpoObserver = null;
  function watchForLateEngraving() {
    if (lateGpoObserver) { lateGpoObserver.disconnect(); lateGpoObserver = null; }
    const root = document.querySelector('.product__info-container');
    if (!root) return;
    /* The engraving step is sorted into a step AND counted (Oct 25: the
       options re-sort could sort it without counting it, so this used to stop
       early and Next skipped engraving). */
    const hasStep = () => {
      const steps = Array.prototype.slice.call(root.querySelectorAll('.olvr-step'));
      const i = steps.findIndex((s) => s.querySelector('.gpo-options-group, .gpo-label'));
      return i >= 0 && i < totalSteps;
    };
    const showing = (g) => {
      if (!g) return false;
      const cs = getComputedStyle(g);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && g.offsetHeight > 0 &&
        !!g.querySelector('input, select, textarea, .gpo-option-image');
    };
    if (hasStep()) return;
    let t = null;
    let tries = 0;
    const stop = () => { if (lateGpoObserver) { lateGpoObserver.disconnect(); lateGpoObserver = null; } };
    const recount = () => {
      if (building) { clearTimeout(t); t = setTimeout(recount, 150); return; }
      if (hasStep()) { stop(); return; }
      const g = root.querySelector('.gpo-options-group');
      if (!showing(g)) return; /* not there or still hidden: wait, don't use a try */
      if (++tries > 3) { stop(); return; } /* the rebuild itself changes the page; don't loop */
      const keep = currentStep;
      firstLoad = true;
      stepsLocked = false;
      buildSteps(true);
      stepsLocked = true;
      if (keep < totalSteps) currentStep = keep;
      buildSteps(true);
      updateButtons(totalSteps);
      updateStepCounter();
      if (hasStep()) stop();
    };
    lateGpoObserver = new MutationObserver(() => { clearTimeout(t); t = setTimeout(recount, 250); });
    lateGpoObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    setTimeout(recount, 300);
    setTimeout(stop, 30000);
  }

  document.addEventListener('vkcl:variant:changed', () => {
    currentStep = 0;
    firstLoad = true;
    initialized = false;
    
    document.querySelectorAll('.gpo-oos--show').forEach(wrapper => {
      delete wrapper.dataset.showMoreInit;
      wrapper.classList.remove('gpo-expanded');
      const btn = wrapper.querySelector('.gpo-show-more-btn');
      if (btn) btn.remove();
      wrapper.querySelectorAll('.gpo-hidden-size').forEach(el => el.classList.remove('gpo-hidden-size'));
    });
    if (sizesCheckInterval) {
      if (sizesCheckInterval.disconnect) sizesCheckInterval.disconnect();
      sizesCheckInterval = null;
    }

    whenBuilderReady(() => {
      buildSteps(true);
      initialized = true;
      updateButtons(totalSteps);
      /* A step deep link must survive the load-time variant-changed reset. */
      if (requestedStep && Date.now() - pageStartedAt < 8000) {
        requestedStepPending = true;
        applyRequestedStep();
        updateButtons(totalSteps);
        updateStepCounter();
      }
      watchForLateEngraving();
    }, 1200);
  });

  function start() {
    if (!document.querySelector('.product-steps-nav')) return;

    const waiter = setInterval(() => {
      const king = document.querySelector('variant-king-combined-listing');
      if (king) {
        clearInterval(waiter);
        firstLoad = true;
        stepsLocked = false;
        initialized = false;
        lastHTML = document.querySelector('variant-selects')?.innerHTML || '';

        whenBuilderReady(() => {
          buildSteps(true);
          stepsLocked = true;
          initialized = true;
          applyRequestedStep();
          updateButtons(totalSteps);
          updateStepCounter();
          watchForLateEngraving();
        }, 2500);
      }
    }, 100);

    setTimeout(() => clearInterval(waiter), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
